module.exports = __webpack_public_path__ + "img/icon_e31.bf952982.png";